module.exports = __webpack_public_path__ + "img/album03_05.5a56cab9.jpg";